import { financingPageBreadcrumb } from '@/components/ui/Breadcrumbs/constants'
import { messages } from './messages'

export const DETAILS = [
  messages.financingOffer.details.freeOrder,
  messages.financingOffer.details.order,
  messages.financingOffer.details.preferentialRate,
  messages.financingOffer.details.deadment,
]

export const BENEFITS = [
  {
    icon: 'deal',
    description: messages.benefits.description.individualConditions,
    text: messages.benefits.text.individualConditions,
  },
  {
    icon: 'diagram',
    description: messages.benefits.description.flexibleSchedule,
    text: messages.benefits.text.flexibleSchedule,
  },
  {
    icon: 'success',
    description: messages.benefits.description.remoteSolution,
    text: messages.benefits.text.remoteSolution,
  },
]

export const STEPS = [messages.steps[1], messages.steps[2], messages.steps[3], messages.steps[4], messages.steps[5]]

export const CONDITIONS_TABLE = [
  {
    captionId: 'conditions',
    values: [
      {
        descriptions: [
          {
            titleId: 'investment',
          },
        ],
      },
      {
        descriptions: [
          {
            titleId: 'preferentialLoan',
          },
        ],
      },
    ],
  },
  {
    captionId: 'creditSum',
    values: [
      {
        descriptions: [
          {
            mobileInnerHeadingId: 'innerHeading.investment',
            textId: 'creditSum.investSber.first',
          },
        ],
      },
      {
        descriptions: [
          {
            mobileInnerHeadingId: 'innerHeading.preferentialLoan',
            textId: 'creditSum.investSber.second',
          },
        ],
      },
    ],
  },
  {
    captionId: 'percentRate',
    values: [
      {
        descriptions: [
          {
            mobileInnerHeadingId: 'innerHeading.investment',
            textId: 'percentRate.investSber.first',
          },
        ],
      },
      {
        descriptions: [
          {
            mobileInnerHeadingId: 'innerHeading.preferentialLoan',
            textId: 'percentRate.investSber.second',
          },
        ],
      },
    ],
  },
  {
    captionId: 'deadline',
    values: [
      {
        descriptions: [
          {
            mobileInnerHeadingId: 'innerHeading.investment',
            textId: 'deadline.investSber.first',
          },
        ],
      },
      {
        descriptions: [
          {
            mobileInnerHeadingId: 'innerHeading.preferentialLoan',
            textId: 'deadline.investSber.second',
          },
        ],
      },
    ],
  },
  {
    captionId: 'provisionv2',
    values: [
      {
        descriptions: [
          {
            textId: 'provision.investSber',
          },
        ],
      },
    ],
  },
  {
    captionId: 'peculiarities',
    values: [
      {
        descriptions: [
          {
            mobileInnerHeadingId: 'innerHeading.investment',
            textId: 'peculiarities.investSber.first',
          },
        ],
      },
      {
        descriptions: [
          {
            mobileInnerHeadingId: 'innerHeading.preferentialLoan',
            textId: 'peculiarities.investSber.second',
          },
        ],
      },
    ],
  },
]

export const ROOT_BREADCRUMBS = [financingPageBreadcrumb]
export const PARTNER_IMAGES = ['sber-business']
